import React from "react";
import ActionDialog from "../../ActionDialog";
import AgentsList from "../../AgentsList";
import {
  changeAgentAction,
  showErrorMessage,
  showSuccessMessage,
} from "../../../../actions";
import { useDispatch } from "react-redux";
import { resolveErrorMessage } from "../../../../util";

const ChangeAgentDialog = ({ open, onClose, user, currentUser, fetchUser }) => {
  const dispatch = useDispatch();

  const changeAgent = async (newAgentId) => {
    try {
      await changeAgentAction({ editedUserId: user.id, newAgentId });
      dispatch(showSuccessMessage("app.edit.sucesfully"));
      await fetchUser();
    } catch (e) {
      const errorMessage = resolveErrorMessage(e);
      dispatch(showErrorMessage(errorMessage));
    } finally {
      onClose();
    }
  };

  return (
    <ActionDialog
      title="app.changeAgent.text"
      open={open}
      onClose={onClose}
      enableConfirmButton={false}
      maxWidth="xs"
    >
      <AgentsList
        currentUser={currentUser}
        user={user}
        onConfirm={changeAgent}
        onClose={onClose}
      />
    </ActionDialog>
  );
};

export default React.memo(ChangeAgentDialog);
